// src/blocks.tsx
// The signed-in user's block list, kept live so blocked people's ads,
// letters, kudos, and requests disappear everywhere right away.
import React, { createContext, useContext, useEffect, useState } from "react";
import { onSnapshot } from "firebase/firestore";
import { blocksCollection } from "./penpal";

export type BlockedUser = { id: string; username: string };

const BlocksContext = createContext<{ ids: Set<string>; list: BlockedUser[] }>({
  ids: new Set(),
  list: [],
});

export const useBlocks = () => useContext(BlocksContext);

export function BlocksProvider({
  uid,
  children,
}: {
  uid?: string;
  children: React.ReactNode;
}) {
  const [list, setList] = useState<BlockedUser[]>([]);

  useEffect(() => {
    if (!uid) {
      setList([]);
      return;
    }
    return onSnapshot(
      blocksCollection(uid),
      (snap) =>
        setList(snap.docs.map((d) => ({ id: d.id, username: d.data().username || "" }))),
      (err) => console.warn("Block list:", err)
    );
  }, [uid]);

  return (
    <BlocksContext.Provider value={{ ids: new Set(list.map((b) => b.id)), list }}>
      {children}
    </BlocksContext.Provider>
  );
}
